import { Component, computed, inject } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonComponent } from '@flowx/angular-ui-toolkit'
import { CommentModeStore } from '@flowx/designer/modules/ai-builder/store/comment-mode.store'

/** Comment mode on the project bar, beside Config / Runtime: pressed, the running UI flow or process
 * lets the maker pick a component and say what should change. It is on the bar only while the
 * store offers it. */
@Component({
  selector: 'flx-comment-mode-toggle',
  imports: [TooltipModule, FlxButtonComponent],
  templateUrl: './comment-mode-toggle.component.html',
  styleUrl: './comment-mode-toggle.component.scss',
  // An empty host must not be a flex item of the bar, or it adds a gap of its own.
  host: { class: 'contents' },
})
export class CommentModeToggleComponent {
  readonly commentMode = inject(CommentModeStore)

  /** Leaving the mode is always on offer; entering it says what is in the way. */
  readonly tooltip = computed(() => {
    if (this.commentMode.on()) {
      return 'Leave comment mode'
    }

    if (!this.commentMode.atBranchHead()) {
      return `Comments are available on the latest version of ${this.commentMode.branchName() || 'this branch'}`
    }

    return this.commentMode.turnOnBlockedByStreaming()
      ? 'Available when the assistant finishes replying'
      : 'Comment on the running app'
  })
}
